export enum Toast{
    Success="success",
    Error="error",
    Waning="warning",
    Info="info"

}
export type ToastType=Toast.Success|Toast.Error|Toast.Info|Toast.Waning;